import { render, staticRenderFns } from "./LeagueTeamLineup.vue?vue&type=template&id=fa827f04&scoped=true"
import script from "./LeagueTeamLineup.vue?vue&type=script&lang=js"
export * from "./LeagueTeamLineup.vue?vue&type=script&lang=js"
import style0 from "./LeagueTeamLineup.vue?vue&type=style&index=0&id=fa827f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa827f04",
  null
  
)

export default component.exports